import React from 'react';
import {SubClientProvider} from '../../../../context/sub-client/State';
import ReceivableListScreen from './receivable-list';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {StackParamList} from '../../../../navigators';

type ScreenProps = NativeStackScreenProps<StackParamList, 'Receivables'>;

export const ReceivableScreen = ({navigation, route}: ScreenProps) => {
  return (
    <SubClientProvider>
      <ReceivableListScreen navigation={navigation} route={route} />
    </SubClientProvider>
  );
};
